export default "__VITE_ASSET__Dd4K_5S0__"